import axios from 'axios';
import { apiService } from './api.service';
import { extractData, handleResponse, handleApiException } from '../helpers/apiResponseHelper';
import { PatchUserContactRequest } from 'models/user-contact';
import { CreateContactPersonRequest, UpdateContactPersonRequest } from 'models/contact-person';

async function getUserContacts(userId: number) {
  return axios
    .get(`${apiService.getApiUrl()}/customer-contact-persons/${userId}`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function getCustomerContacts(customerId: number) {
  return axios
    .get(`${apiService.getApiUrl()}/customer-contact-persons/customer/${customerId}`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function getCurrentUserContactWithSync(userId: number, contactId: number) {
  return axios
    .get(`${apiService.getApiUrl()}/customer-contact-persons/${userId}/contact/${contactId}/sync`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function updateProfile(userId: number, contactId: number, request: PatchUserContactRequest) {
  return axios
    .patch(`${apiService.getApiUrl()}/customer-contact-persons/profile/${userId}/contact/${contactId}`, {
      ...request,
      bankAccountNumber: request.eInvoice ? request.bankAccountNumber: undefined
    })
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function createContactPerson(contactPersonId: number, request: CreateContactPersonRequest) {
  return axios
    .post(`${apiService.getApiUrl()}/customer-contact-persons`, request, { params: { contactPersonId } })
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function updateContactPerson(updatableContactId: number, contactPersonId: number, request: UpdateContactPersonRequest) {
  return axios
    .patch(`${apiService.getApiUrl()}/customer-contact-persons/${updatableContactId}`, request, { params: { contactPersonId } })
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function deleteContactPerson(deletableContactId: number, contactPersonId: number) {
  return axios
    .delete(`${apiService.getApiUrl()}/customer-contact-persons/${deletableContactId}`, { params: { contactPersonId } })
    .catch(handleApiException);
}

const CustomerContactService = {
  getUserContacts,
  getCustomerContacts,
  getCurrentUserContactWithSync,
  updateProfile,
  createContactPerson,
  updateContactPerson,
  deleteContactPerson
};

export default CustomerContactService;
